import React from 'react';
import OlcEditIcon from '~/components/General/OlcEditIcon';

const EditNoteCIcon = ({ className }) => (
  <OlcEditIcon className={className} size={16} sx={{ color: '#6F737A' }} />
);

export default EditNoteCIcon;
